<p-dialog
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '20vw' }"
  [draggable]="false"
  [resizable]="true"
  styleClass="order-dialog">
  <ng-template pTemplate="header">
    <div class="header-modal pb-4 has-border w-100 d-flex align-items-center">
      <h2 class="me-2">Available IP's</h2>
    </div>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <jni-spinner></jni-spinner>
    </div>
  </ng-template>

  <div class="orders py-3 pagination-order">
    <p-table
      #invoiceTable
      responsiveLayout="scroll"
      [value]="projectInvoicesProposalList"
      styleClass="p-datatable-customers ordersListing search-more"
      [rowHover]="true"
      [filterDelay]="0">
      <ng-template pTemplate="header">
        <tr>
          <th class="col-center">IP #</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-invoice let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="invoice"
          [pSelectableRowIndex]="rowIndex">
          <td class="col-center">
            <a class="link" (click)="redirectToIPSummary(invoice.ProposalId)">
              {{ invoice.ProposalId }}</a
            >
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 justify-content-end">
      <button
        type="button"
        (click)="closeModalDialog()"
        class="btn btn-secondary me-3">
        Cancel
      </button>
    </div>
  </ng-template>
</p-dialog>
